import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { BaseParamsService } from '../base-params.service';
import { map, share } from 'rxjs/operators';
import { Translations } from '../../shared/models/translations';
import { ApiTranslations, ApiTranslationsAttributes } from '@app/core/_models/api-translations';
import { toHttpParams } from '@app/shared/utils/to-http-params';
import * as R from 'ramda';
import { LOCALE_HEADER, LOYALTY_CLUB_SLUG_HEADER } from '@app/core/consts';

@Injectable()
export class TranslatorService {

  private observable: Observable<Translations>;
  private currentLanguage: string | null;
  private currentAttributes: ApiTranslationsAttributes[] | null = null;

  constructor(private http: HttpClient, private baseParamsService: BaseParamsService) {}

  public getTranslations(language: string, attributes: ApiTranslationsAttributes[]): Observable<Translations> {
    if (this.observable &&
      language === this.currentLanguage &&
      R.equals(attributes, this.currentAttributes)
    ) {
      return this.observable;
    }
    this.currentAttributes = attributes;
    this.currentLanguage = language;
    return this.observable = this.getTranslationsObservable(language, attributes);
  }


  private getTranslationsObservable(
    language: string,
    attributes: ApiTranslationsAttributes[],
  ): Observable<Translations> {
    return this.http.get(
      this.translatorUrl(),
      {
        headers: this.translatorHeaders(language),
        params: toHttpParams({ attributes }),
      }).pipe(
      map((json: { translations: ApiTranslations }) => new Translations(json.translations)),
      share(),
    );
  }

  private translatorUrl(): string {
    return `${environment.webforms_api}/v4/loyalty_clubs/translations`;
  }

  private translatorHeaders(language: string): HttpHeaders {
    return new HttpHeaders({
      [LOYALTY_CLUB_SLUG_HEADER]: this.baseParamsService.slug,
      [LOCALE_HEADER]: language,
    });
  }
}
